export default {
  props: ['coursework'],
  template: '#coursework_card_template',
  computed: {
    isActive() {
      return !this.coursework.is_completed && this.coursework.is_active;
    },
    isUpcoming() {
      return this.coursework.is_draft || this.coursework.is_upcoming;
    },
    isEnded() {
      return !this.coursework.is_completed && this.coursework.is_ended;
    },
    isCompleted() {
      return this.coursework.is_completed;
    },
    dueNotice() {
      const time_frame = Kadenze.Util.getMomentDate(this.coursework.formatted_due_date).fromNow(true);
      return `Due in ${time_frame}`;
    },
    overdueNotice() {
      const time_frame = Kadenze.Util.getMomentDate(this.coursework.formatted_due_date).fromNow(true);
      return `${time_frame} over due`;
    },
    assessmentDueNotice() {
      let subject = null;
      if (this.coursework.peer_assessment_pending) {
        subject = 'Peer assessment';
      }
      if (this.coursework.participation_assessment_pending) {
        if (_.isEmpty(subject))
          subject = 'Participation';
        else
          subject += ' and participation';
      }
      return subject + ' due';
    }
  },
  methods: {
    showDisabledModal(coursework) {
      if (coursework.modal) {
        new Kadenze.Notice.info(coursework.modal);
      } else {
        return true;
      }
    }
  }
};
